/// Get bearing of point 2 from point 1
/// Leaflet PolylineMeasure plugin by @ppete2

import type { LatLng } from "@/models"
import L, { type LatLngTuple } from "leaflet"

/// https://github.com/ppete2/Leaflet.PolylineMeasure/blob/9908e5a2cbd2753c335ac758f3559ba9da6f99e9/Leaflet.PolylineMeasure.js#L740
export function calcAngle(p1: LatLng, p2: LatLng, outbound = true): number {
	const p1Lat = (p1.latitude / 180) * Math.PI
	const p1Lng = (p1.longitude / 180) * Math.PI
	const p2Lat = (p2.latitude / 180) * Math.PI
	const p2Lng = (p2.longitude / 180) * Math.PI
	const y = Math.sin(p2Lng - p1Lng) * Math.cos(p2Lat)
	const x = Math.cos(p1Lat) * Math.sin(p2Lat) - Math.sin(p1Lat) * Math.cos(p2Lat) * Math.cos(p2Lng - p2Lng)
	const bearing = Math.round((Math.atan2(y, x) * 180) / Math.PI + (outbound ? 360 : 180))
	return bearing % 360
}

export function calcDistance(p1: LatLng, p2: LatLng) {
	const angle = 35

	const from: LatLngTuple = [p1.latitude, p1.longitude]
	const to: LatLngTuple = [p2.latitude, p2.longitude]
	const coords: LatLngTuple[] = [from, to]

	const distance = L.latLng(from).distanceTo(to)
	const nauticalDistance = distance / 1852
	const bearing = calcAngle(p1, p2)

	const distanceText = `Distance: ${nauticalDistance.toFixed(2)}nm; Bearing: ${bearing.toFixed(1)}°`

	return {
		from,
		to,
		coords,
		distance,
		nauticalDistance,
		bearing,
		angle,
		distanceText,
	}
}
